/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Overview_Round_CompleteInputs */



/**
* | output |
* | --- |
* | "Round {n} complete." |
*
* @param {Overview_Round_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_round_complete = /** @type {((inputs: Overview_Round_CompleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Round_CompleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} terminée.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} completada.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} completa.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} completato.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} complete.`)
});